module.exports = ".close-doc {\n  float: none;\n  background: #b3b3b3 !important;\n  padding: 0.75rem 1.25rem !important;\n  cursor: pointer !important;\n  border-radius: 499rem !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/shared/attached-document/attached-document.component.scss
// module id = ./src/app/forms/shared/attached-document/attached-document.component.scss
// module chunks = main